export enum CreateEventError
{
    /// <summary>
    /// Indicates a server error.
    /// </summary>
    ServerError,

    /// <summary>
    /// Indicates an invalid case.
    /// </summary>
    InvalidCase,

    /// <summary>
    /// Indicates invalid date and time values.
    /// </summary>
    InvalidDateTimes,

    /// <summary>
    /// Indicates an error occurred while creating the event.
    /// </summary>
    ErrorCreatingEvent,

    /// <summary>
    /// Indicates the user is not the owner of the event.
    /// </summary>
    UserNotOwner,

    /// <summary>
    /// Indicates the calendar event suggestion has already been used.
    /// </summary>
    SuggestionAlreadyUsed,

    /// <summary>
    /// Action disabled for user
    /// e.g. user is not ultimate and cannot create calendar events based on suggestions.
    /// </summary>
    ActionDisabled,
}